import { MONITOR_TWITCH_CLIPS } from 'root/src/shared/descriptions/endpoints/endpointIds'
import cronJobPayloadSchema from 'root/src/shared/descriptions/endpoints/schemas/requestSchemas/cronJobPayloadSchema'

export default {
	[MONITOR_TWITCH_CLIPS]: {
		payloadSchema: cronJobPayloadSchema,
		isCron: true,
	},
}
